
/**
 * 退款申请弹框
 */
import React, { Component } from 'react';
import { Modal, Form, Input,Button } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

const fields = [{
    "text": "备注",
    "field": "remark",
    "textarea": true,
}];

class PayOrderApplyForm extends Component {
    state = {
        visible: false
    }
    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let orderId = this.props.editData
            if (orderId !== undefined && orderId != null) {
                values["orderId"] = orderId;
            }
            http.post({
                url: '/payOrder/applyRefund',
                data: values,
                success: () => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("退款申请成功！");
                }
            });
        });
    };

    fun1 = () => {
        console.log("1")
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.textarea ? <Input.TextArea />
                                    : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };


    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={500}
                visible={visible}
                title="退款申请"
                maskClosable={false}
                onCancel={onCancel}
                afterClose={() => { this.props.form.resetFields() }}
                footer={[
                    <Button key="apply" type="primary" onClick={this.save}>提交</Button>,
                    <Button key="close" type="default"  onClick={onCancel}>关闭</Button>,
                ]}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const PayOrderApplyFormEdit = Form.create()(PayOrderApplyForm);

export default PayOrderApplyFormEdit;